//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClickOutside from 'vue-click-outside'

export default {
  computed: {
    isOpen: {
      get() {
        //if we have other stakes
        return this.$store.state.leftSidebarOpen
      },
      set(value) {
        this.$store.commit('openLeftSidebar', true)
      }
    },
    headerSubLinks() {
      let links = _.get(this.$store.state, 'globals.subheader_links', [])
      links = _.reject(links, link => {
        if(_.get(link, 'visibility') == 'authenticated' && !this.user) {
          return true
        }
        if(_.get(link, 'visibility') == 'guest' && this.user) {
          return true
        }
        return false
      })
      return links;
    },
    clubPromotionsLink(){
      
      return _.first(_.filter(this.headerSubLinks, lnk => lnk.url === '/club-promociones/'));
    },
    complianceLinks() {
      return _.filter(this.headerSubLinks, lnk =>
        (this.complianceLinksMapping.indexOf(lnk.url) > -1 || this.complianceLinksMapping.indexOf(lnk.action) > -1));
    },
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      time: null,
      current: null,
      pages: [],
      complianceLinksMapping: [
        '/ayuda/proteccion-de-menores/', 
        'https://www.ordenacionjuego.es/participantes-juego/juego-seguro/rgiaj',
        'profile/responsible_gaming'
      ],
    }
  },
  async created() {
    setInterval(this.getNow, 1000)

    //move this to strapi
    this.pages = [
        {url:'/ayuda/', label: this.$t('Help Center'), icon: 'las la-life-ring'},
        {url:'/ayuda/contacto/', label: this.$t('Contact Us'), icon: 'las la-comments'},
        {url:'/ayuda/terminos-y-condiciones/', label: this.$t('Terms and Conditions'), icon: 'las la-file-alt'},
        {url:'/ayuda/informacion-bono/', label: this.$t('Bonus Conditions'), icon: 'las la-star'},
        {url:'/ayuda/reglas-deportivas/', label: this.$t('Sport Betting Rules'), icon: 'las la-gavel'},
        {url:'/ayuda/faq/', label: this.$t('FAQs'), icon: 'las la-question-circle'},
    ]
  },
  methods: {
    async openSettings() {
      this.$modal.show('modal-settings');
      this.$store.commit('openLeftSidebar', false)
    },
    async goTo(section = null, newTab = false) {
      if(this.system == 'app') {
        newTab = false;
      }
      if(newTab){
        let routeData = this.$router.resolve(this.localePath(section));
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push(this.localePath(section))
      }
      this.$store.commit('openLeftSidebar', false)
    },
    goToComplianceLink(link) {
      if (_.startsWith(link.url, 'http')) {
        window.open(link.url, '_blank');
      } else if(!_.get(link, 'url') && _.get(link, 'action')) {
        this.openCashier(_.get(link, 'action'))
      } else {
        this.$router.push(this.localePath(link.url))
      }      
      this.$store.commit('openLeftSidebar', false)
    },
    async openPage(path) {
      this.$store.commit('openLeftSidebar', false)
      this.$router.push({path: path});

      //this.$router.push(this.localePath(path))
    },
    async getNow() {
      this.time = this.$date().format('FF')
    },
    async openLeftSidebar() {
      this.$store.commit('openLeftSidebar', true)
    },
    open() {
      this.$store.commit('openLeftSidebar', true)
    },
    close() {
      this.$store.commit('openLeftSidebar', false)
    },
    goBack() {
      this.$router.back()
    }
  }
}
